import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../Components/Sidebar";
import Header from "../Components/Header";
import Select from "react-select";
import ReactDatatable from "@ashvin27/react-datatable";
import EditExchangeModal from "../Modals/EditExchangeModal";
import DeleteExchangeModal from "../Modals/DeleteExchangeModal";
import AddExchangeModal from "../Modals/AddExchageModal";
import { getExchanges } from "../actions/currency";
import { address_showing } from "../lib/displayStatus";
import { CURRENT_CHAIN_ID } from "../Hooks/useWeb3";
const Exchanges = () => {
  useEffect(() => {
    getAllExchanges();
  }, []);

  // add Exchange modal
  const [showAddExchange, setShowAddExchange] = useState(false);

  const handleShowAddExchange = () => setShowAddExchange(true);
  const handleCloseAddExchange = () => setShowAddExchange(false);

  // edid Exchange modal
  const [showEditExchange, setShowEditExchange] = useState(false);
  const [editRecord, setEditRecord] = useState();

  const handleShowEditExchange = (record) => {
    setEditRecord(record);
    setShowEditExchange(true);
  };

  const handleCloseEditExchange = () => {
    setShowEditExchange(false);
    setEditRecord({});
  };

  // delete Exchange modal

  const [showDeleteExchange, setShowDeleteExchange] = useState(false);
  const [deleteRecord, setDeleteRecord] = useState();

  const handleShowDeleteExchange = (record) => {
    setDeleteRecord(record);
    setShowDeleteExchange(true);
  };

  const handleCloseDeleteExchange = () => setShowDeleteExchange(false);

  const [exchanges, setExchanges] = useState();
  const [pageNumer, setPageNumer] = useState(1);
  const [limit, setLimit] = useState(10);
  const [count, setCount] = useState(0);

  // exchanges?.map((val) => {
  //   val.factory = address_showing(val.factory);
  //   val.router = address_showing(val.router);
  // });

  const handlePagination = async (index) => {
    let reqData = {
      page: index.page_number,
      limit: index.page_size,
    };
    // let skip = (index.page_number - 1) * index.page_size;
    // let loadinterval = index.page_number * index.page_size;
    setPageNumer(index.page_number);
    setLimit(index.page_size);
    const { status, message, result, count } = await getExchanges(reqData);
    setExchanges(result);
    setCount(count);
    // setInterval(loadinterval);
  };

  const getAllExchanges = async () => {
    try {
      let reqData = {
        page: pageNumer,
        limit: limit,
        chainId: 'all'
      };
      let { status, message, result, count } = await getExchanges(reqData);
      console.log(status, message, result, "status, message, result");
      if (status == "success") {
        setExchanges(result);
        setCount(count);
      }
    } catch (err) {
      console.log("getAllExchanges_err", err);
    }
  };

  const state = [
    {
      name: (
        <p className="exchange_table_values text-center">{exchanges?.name}</p>
      ),
      factoryRouterAddress: (
        <p className="exchange_table_values text-center">
          {exchanges?.factory}
        </p>
      ),
    },
    {
      name: <p className="exchange_table_values text-center">Demo</p>,
      factoryRouterAddress: (
        <p className="exchange_table_values text-center">t34tegr34tgsdfas3g</p>
      ),
    },
    {
      name: <p className="exchange_table_values text-center">Demo</p>,
      factoryRouterAddress: (
        <p className="exchange_table_values text-center">t34tegr34tgsdfas3g</p>
      ),
    },
  ];

  const columns = [
    {
      key: "name",
      text: "Name",
      className: "exchange_table_values text-center",
      align: "center",
      sortable: false,
    },
    {
      key: "factory",
      text: "Factory",
      className: "exchange_table_values text-center",
      align: "center",
      sortable: false,
      cell: (record) => {
        return (
          <div className="d-flex justify-content-center align-items-center gap-2">
            <p>{address_showing(record.factory)}</p>
          </div>
        );
      },
    },
    {
      key: "router",
      text: "Router",
      className: "exchange_table_values text-center",
      align: "center",
      sortable: false,
      cell: (record) => {
        return (
          <div className="d-flex justify-content-center align-items-center gap-2">
            <p>{address_showing(record.router)}</p>
          </div>
        );
      },
    },
    {
      key: "action",
      text: "Action",
      className: "activity",
      align: "center",
      sortable: false,
      cell: (record) => {
        return (
          <div className="d-flex justify-content-center align-items-center gap-2">
            <button
              className="cmn_plain_btn"
              onClick={() => {
                handleShowEditExchange(record);
              }}>
              <img
                src={require("../assets/images/editer.svg").default}
                className="img-fluid table_activity_img"
              />{" "}
            </button>
            <button
              className="cmn_plain_btn"
              onClick={() => {
                handleShowDeleteExchange(record._id);
              }}>
              <img
                src={require("../assets/images/trash.svg").default}
                className="img-fluid table_activity_img"
              />{" "}
            </button>
          </div>
        );
      },
    },
  ];

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50],
    filename: "Emailtemplates",
    no_data_text: "No Email Templates found!",
    language: {
      length_menu: "Show _MENU_ result per page",
      filter: "Filter in records...",
      info: "Showing _START_ to _END_ of _TOTAL_ records",
      pagination: {
        first: "First",
        previous: "Previous",
        next: "Next",
        last: "Last",
      },
    },
    show_length_menu: false,
    show_filter: false,
    show_pagination: true,
    show_info: false,
  };

  const extraButtons = [
    {
      className: "btn btn-primary buttons-pdf",
      title: "Export TEst",
      children: [
        <span>
          <i
            className="glyphicon glyphicon-print fa fa-print"
            aria-hidden="true"></i>
        </span>,
      ],
      onClick: (event) => {
        console.log(event);
      },
    },
    {
      className: "btn btn-primary buttons-pdf",
      title: "Export TEst",
      children: [
        <span>
          <i
            className="glyphicon glyphicon-print fa fa-print"
            aria-hidden="true"></i>
        </span>,
      ],
      onClick: (event) => {
        console.log(event);
      },
      onDoubleClick: (event) => {
        console.log("doubleClick");
      },
    },
  ];
  return (
    <>
      <Container fluid className="common_bg position-relative">
        <div className="liner"></div>
        <Row>
          <Col xl={2} lg={0} className="p-0 d-none d-xl-block">
            <Sidebar />
          </Col>
          <Col xl={10} lg={12}>
            <Header title={"Exchanges"} />
            <div className="text-end my-4">
              <button
                className="orange_small_primary"
                onClick={() => {
                  handleShowAddExchange(true);
                }}>
                Add
              </button>
            </div>

            <div className="common_page_scroller pb-5 pe-2">
              <div className="exchange_table_holder dashboard_box rounded-3">
                <ReactDatatable
                  config={config}
                  records={exchanges}
                  columns={columns}
                  extraButtons={extraButtons}
                  dynamic={true}
                  total_record={count}
                  onChange={(e) => {
                    handlePagination(e);
                  }}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      {/* modals */}
      <AddExchangeModal
        show={showAddExchange}
        handleClose={handleCloseAddExchange}
        getAllExchanges={getAllExchanges}
      />

      <EditExchangeModal
        show={showEditExchange}
        record={editRecord}
        handleClose={handleCloseEditExchange}
        getAllExchanges={getAllExchanges}
      />
      <DeleteExchangeModal
        show={showDeleteExchange}
        record={deleteRecord}
        handleClose={handleCloseDeleteExchange}
        getAllExchanges={getAllExchanges}
      />
      {/* end of modals */}
    </>
  );
};

export default Exchanges;
